import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'sonner';
import api, { formatApiError } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import Logo from '@/components/Logo';
import Footer from '@/components/Footer';

export default function ResetPassword() {
	const [params] = useSearchParams();
	const token = params.get('token') || '';
	const navigate = useNavigate();
	const [pw, setPw] = useState('');
	const [pw2, setPw2] = useState('');
	const [submitting, setSubmitting] = useState(false);

	useEffect(() => {
		if (!token) toast.error('Missing reset token');
	}, [token]);

	const submit = async (e) => {
		e.preventDefault();
		if (pw !== pw2) {
			toast.error('Passwords do not match');
			return;
		}
		setSubmitting(true);
		try {
			await api.post('/auth/reset-password', { token, new_password: pw });
			toast.success('Password updated. Please sign in.');
			navigate('/login');
		} catch (err) {
			toast.error(formatApiError(err));
		} finally {
			setSubmitting(false);
		}
	};

	return (
		<div className="min-h-screen flex items-center justify-center mesh-bg px-4 py-10">
			<div className="w-full max-w-md card-soft p-8">
				<Logo />
				<h2 className="mt-6 text-3xl font-heading font-bold tracking-tight text-slate-900">Reset password</h2>
				<form onSubmit={submit} className="mt-8 space-y-4">
					<Label htmlFor="pw">New password</Label>
					<Input id="pw" type="password" required minLength={6} value={pw} onChange={(e) => setPw(e.target.value)} className="h-12 rounded-xl" data-testid="reset-password-input" />
					<Label htmlFor="pw2">Confirm new password</Label>
					<Input id="pw2" type="password" required value={pw2} onChange={(e) => setPw2(e.target.value)} className="h-12 rounded-xl" data-testid="reset-password-confirm-input" />
					<Button type="submit" disabled={submitting || !token} className="w-full h-12 rounded-full bg-[#1E3A8A] hover:bg-[#1E40AF] text-white font-semibold" data-testid="reset-submit-button">
						{submitting ? 'Updating…' : 'Update password'}
					</Button>
				</form>
				<p className="mt-6 text-sm text-center">
					<Link to="/login" className="font-semibold text-emerald-700 hover:underline">Back to sign in</Link>
				</p>
			</div>
			<Footer compact className="mt-8" />
		</div>
	);
}
